
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.307 7.054h6.688a1.95 1.95 0 011.74 1.068l3.195 6.3a.488.488 0 01-.435.708H6.917a1.95 1.95 0 01-1.727-1.044L1.875 7.768a.488.488 0 01.432-.714z","fill":"#6DBC3F"}}),_c('path',{attrs:{"d":"M15.161.705l-3.879 5.079a1.95 1.95 0 00-.173 2.098l3.36 6.336a.488.488 0 00.82.065l3.86-5.11a1.95 1.95 0 00.167-2.086L15.98.773a.488.488 0 00-.819-.068zM14.216 23.576l2.36-3.013c.265-.34.307-.803.107-1.185l-2.025-3.865a.274.274 0 00-.461-.039l-2.37 3.127c-.26.343-.295.805-.092 1.183l2.023 3.754a.274.274 0 00.458.038z","fill":"#00A6EA"}}),_c('path',{attrs:{"d":"M22.048 19.785H18.05c-.417 0-.798-.237-.983-.61l-1.86-3.757a.274.274 0 01.243-.396l3.87-.047c.414-.005.796.224.987.591l1.985 3.818a.274.274 0 01-.244.401z","fill":"#6DBC3F"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    